import { makeGraphQLQuery } from '../request.gql';

/**
 * Family
 */
export const queryFamily = async ({token}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `query {
            family {
                id
                projection
                client
                dependents {
                    id
                    name
                    relationship {
                        label,
                    }
                }
                coreMember {
                    id
                    name
                }
            }
        }`,
        variables: {},
        token,
    });
    if (e) return e;
    return r.family;
};